import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AutofocusDirective,
  FormFieldComponent,
  FormFieldNewComponent,
  MaxNumberDirective,
  MinNumberDirective,
  ModalComponent,
  OnlyNumberDirective,
  SdvorButtonComponent,
  SdvorSelectModule,
} from '@sdvor/shared/ui';
import { YandexMapModule } from '@sdvor/yandex-maps/ui';
import { FormErrorsComponent, IconModule } from '@spartacus/storefront';
import { SdvorDeliveryAddressDialogModalComponent } from './delivery-address-dialog-modal/delivery-address-dialog-modal.component';
import { DeliveryAddressDialogComponent } from './delivery-address-dialog.component';
import { DeliveryAddressMapComponent } from './delivery-address-map/delivery-address-map.component';

@NgModule({
  declarations: [DeliveryAddressDialogComponent, SdvorDeliveryAddressDialogModalComponent, DeliveryAddressMapComponent],
  imports: [
    NgIf,
    AsyncPipe,
    NgClass,
    ModalComponent,
    SdvorSelectModule,
    FormFieldComponent,
    YandexMapModule,
    FormFieldNewComponent,
    IconModule,
    ReactiveFormsModule,
    FormErrorsComponent,
    SdvorButtonComponent,
    AutofocusDirective,
    MaxNumberDirective,
    MinNumberDirective,
    OnlyNumberDirective,
  ],
  exports: [DeliveryAddressDialogComponent, SdvorDeliveryAddressDialogModalComponent, DeliveryAddressMapComponent],
})
export class SdvorDeliveryAddressDialogModule {}
